import { LOG_OUT } from "../login/action";
import { HIDE_WITHOUT_LOGIN_PRELOADER, SET_DRIVER_CITATION_STATES, SET_DRIVER_CREDIT_CARD_VALUE, SHOW_WITHOUT_LOGIN_PRELOADER } from "./action";

export const defaultState = {
  driverCitationStateList: [],
  driverCreditCardValue:[],
  withoutLoginPreLoader:false
};

function driverCitationReducer(state = defaultState, action) {
  switch (action.type) {
    case SET_DRIVER_CITATION_STATES:
      return {
        ...state,
        driverCitationStateList: action.payload,
      };
      case SET_DRIVER_CREDIT_CARD_VALUE:
        return {
          ...state,
          driverCreditCardValue: action.payload,
        };
        case SHOW_WITHOUT_LOGIN_PRELOADER:
          return{
            ...state,
            withoutLoginPreLoader:true
          }
          case HIDE_WITHOUT_LOGIN_PRELOADER:
            return{
              ...state,
              withoutLoginPreLoader:false
            }
    case LOG_OUT:
      return defaultState;
    default:
      return state;
  }
}

export default driverCitationReducer;
